import React from 'react'

import moment from 'moment'

const BkFlowRestaurantsConfirmationCard = props =>  {
	const {
		configData,
		restaurantCardData,
		restaurantKey,
	} = props

	const hotelLabels = configData.hotel.labels[0]

	return (
		<div
			className="bk-flow-restaurants__confirmation-card"
			key={restaurantKey}
		>
			{ restaurantCardData.venue &&
				restaurantCardData.venue.name &&
				<p className="reservation-title">{ restaurantCardData.venue.name }</p>
			}

			{ restaurantCardData.reservation &&
				restaurantCardData.reservation.id &&
					<p className="u-remove-margin reservation-id">
						<span className="u-font-bold">{ hotelLabels && hotelLabels.Reservation ? hotelLabels.confirmationNumber : 'Reservation'}:</span>
						&nbsp;
						{ restaurantCardData.reservation.id }
					</p>
			}

			{ restaurantCardData.reservation &&
				restaurantCardData.reservation.date &&
					<p className="u-remove-margin reservation-date">
						<span className="u-font-bold">{ hotelLabels && hotelLabels.date ? hotelLabels.date : 'Date' }:</span>
						&nbsp;
						{ moment(restaurantCardData.reservation.date, 'YYYY-MM-DD').format('ddd, MMM Qo, YYYY') }
					</p>
			}

			{ restaurantCardData.reservation &&
				restaurantCardData.reservation.arrival_time &&
					<p className="u-remove-margin reservation-time">
						<span className="u-font-bold">{ hotelLabels && hotelLabels.time ? hotelLabels.time : 'Time' }:</span>
						&nbsp;
						{ restaurantCardData.reservation.arrival_time }
					</p>
			}

			{ restaurantCardData.reservation &&
				restaurantCardData.reservation.max_guests &&
					<p className="u-remove-margin reservation-party">
						<span className="u-font-bold">{ hotelLabels && hotelLabels.guests ? hotelLabels.guests : 'Guests' }:</span>
						&nbsp;
						{ restaurantCardData.reservation.max_guests }
					</p>
			}
		</div>
	)
}

export default BkFlowRestaurantsConfirmationCard



// WEBPACK FOOTER //
// ./src/components/restaurants/elements/BkFlowRestaurantsConfirmationCard.js